import React from 'react';
import { SEOHead } from '@/components/SEOHead';
import { useLanguage } from '@/contexts/LanguageContext';
import { TrainingHero } from '@/components/training/TrainingHero';
import { UpcomingTrainings } from '@/components/home/UpcomingTrainings';
import { TrainingTools } from '@/components/training/TrainingTools';
import { TrainingStats } from '@/components/training/TrainingStats';
import { TrainingPrograms } from '@/components/training/TrainingPrograms';
import { TrainingTestimonials } from '@/components/training/TrainingTestimonials';
import { TrainingCaseStudies } from '@/components/training/TrainingCaseStudies';
import { TrainingIncludes } from '@/components/training/TrainingIncludes';
import { TrainingArticles } from '@/components/training/TrainingArticles';
import { TrainingCTA } from '@/components/training/TrainingCTA';
import { TrainingFAQ } from '@/components/training/TrainingFAQ';
import { TrainingCRFPA } from '@/components/training/TrainingCRFPA';

export const TrainingPage = () => {
  const { language } = useLanguage();

  const seoTitle = language === 'fr' ?
  "Formation IA Avocat | Gaius - Formation juridique IA, FCO, CPF, FIF-PL, OPCO, Mon compte formation" :
  "Legal AI Training for Lawyers | Gaius - AI Training CLE, CPF, OPCO Eligible";

  const seoDescription = language === 'fr' ?
  "Formation IA avocat : FCO, CPF, Mon compte formation, OPCO, FIF-PL. Formation continue obligatoire en intelligence artificielle juridique. ChatGPT, Claude, Gemini pour avocats et juristes. Modules M&A, contentieux, corporate, fiscal, social, immobilier, pénal. Formation sur-mesure cabinet." :
  "Legal AI training: CLE, CPF, OPCO eligible. Continuing legal education in AI for lawyers. ChatGPT, Claude, Gemini for legal professionals. Practice-area modules. Custom law firm training.";

  const seoKeywords = language === 'fr' ?
  "formation ia avocat, ia juridique, ia avocat, ia droit, formation continue avocat, formation juridique, fco avocat ia, opco formation avocat, cpf avocat, mon compte formation avocat, fif-pl avocat ia, formation ia juriste, formation ia notaire, prompt engineering juridique, chatgpt avocat, claude legal, gemini droit, formation cpf juriste" :
  "legal ai training, ai for lawyers, ai law, formation ia, mandatory cle ai, legal prompt engineering, law firm ai training, in-house counsel ai, continuing legal education ai, cpf lawyer, chatgpt lawyer";

  const imageObjectSchema = {
    "@context": "https://schema.org",
    "@type": "ImageObject",
    "name": "Formation IA juridique pour avocats - 6 prérequis ChatGPT",
    "description": "Programme complet de formation à l'intelligence artificielle pour avocats : maîtrise de ChatGPT, Claude, Gemini avec focus sécurité et déontologie CNB",
    "contentUrl": "https://gaius-tech.com/images/formation-ia-juridique-avocat-prerequis-chatgpt.webp",
    "creator": {
      "@type": "Organization",
      "name": "Gaius Legal AI",
      "url": "https://gaius-tech.com"
    },
    "keywords": "formation IA juridique, ChatGPT avocat, Claude legal, IA droit, prompt engineering juridique, formation avocat CPF, FIF PL IA, Harvey AI alternative, hallucination IA vérification, automatisation cabinet avocat, juriste IA, CRFPA IA, formation OPCO juridique, FCO avocat IA"
  };

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Course",
      "name": language === 'fr' ? "Formation IA Juridique pour Avocats" : "Legal AI Training for Lawyers",
      "description": seoDescription,
      "provider": {
        "@type": "Organization",
        "name": "Gaius",
        "url": "https://gaius-tech.com"
      },
      "hasCourseInstance": [
        {
          "@type": "CourseInstance",
          "name": language === 'fr' ? "Formation Continue Obligatoire - IA Avocat" : "Mandatory CLE - Legal AI",
          "courseMode": "Blended",
          "courseWorkload": "PT7H"
        },
        {
          "@type": "CourseInstance",
          "name": language === 'fr' ? "Formation Ad Hoc Cabinet" : "Custom Firm Training",
          "courseMode": "Blended"
        }
      ]
    },
    imageObjectSchema
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        canonicalUrl={language === 'fr' ? "https://gaius-tech.com/formation-ia-avocat" : "https://gaius-tech.com/legal-ai-training-lawyers"}
        alternateUrlFr="https://gaius-tech.com/formation-ia-avocat"
        alternateUrlEn="https://gaius-tech.com/legal-ai-training-lawyers"
        structuredData={structuredData} />

      
      <TrainingHero />
      <UpcomingTrainings />
      <TrainingTools />
      <TrainingStats />
      <TrainingPrograms />
      <TrainingTestimonials />
      <TrainingCaseStudies />
      <TrainingIncludes />
      <TrainingCRFPA />
      <TrainingArticles />
      <TrainingFAQ />
      <TrainingCTA />
    </div>);

};